<div class="mode-wrapper">
  <div class="mode-container">
    @for (selectionMode of selectionModes; track selectionMode) {
      <app-selection-mode
        [id]="selectionMode.id"
        [active]="(selectionMode$ | async)?.mode === selectionMode.selectionMode"
        [asset]="selectionMode.asset"
        [alt]="selectionMode.id.toString()"
        (clickItem)="toggleSelectionMode(selectionMode)"
        >
      </app-selection-mode>
    }
  </div>
</div>
